<script setup lang="ts">
/**
 * The item view for a search result in the sidebar. This is used in the sidebar to represent
 * a search result, and it renders similar to a folder (i.e. a "smart" folder)
 *
 * TODO
 * - [ ] Selectable rather than just clickable (like the FileItem)
 * - [ ] Ghosted if this search is the current search in the main view
 * - [ ] draggable into sidebar (but not main view)
 */
import agentSearchFolder from "~/assets/images/files/folder/agent_search@64.webp"

const props = defineProps({
  search: null,
  location: null
})

const { navigateToSearch } = useNavigation()
const { searchIdAttr } = useGlobals()
const { selectSearch, isSelected, isSelectedIn } = useSelection()
const { currentSearch } = useNavigation()
const selected = computed(() => isSelected(props.search.searchId()))
const ghosted = computed(() => {
  if (isSelectedIn(props.search.searchId(), "agent"))
    return false
  else if (selected.value || (currentSearch.value?.searchId() === props.search.searchId()))
    return true
  else if (selected.value)
    return true
  return false
})
const onClicked = () => {
  if (selected.value)
    navigateToSearch(props.search, false)
  else
    selectSearch(props.search, props.location)
}
</script>

<template>
  <div
    :[dataAttr(searchIdAttr)]="search?.searchId()"
    class="search-ref"
    :class="{ selected, ghosted }"
    @click="onClicked()"
  >
    <div class="search-thumbnail">
      <img draggable="false" :src="agentSearchFolder">
    </div>
    <div class="contents">
      <div class="description">
        {{ search.description() ?? "Search Results" }}
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-ref
  @apply block
  @apply flex items-center gap-[#{$panel-agent-gap-file-default}]
  @apply px-1 py-0.75 rounded-[8px] my-2 -mx-1
  @apply t-property-sm
  @apply cursor-pointer
  &:hover
    @apply bg-[#{$panel-agent-bg-file-hover}]
  &.selected
    @apply bg-[#{$global-blue-primary}]
  &.ghosted
    @apply bg-[#{$global-blue-accent}]

.search-thumbnail
  @apply h-8 w-8 aspect-square flex-none

.contents
  @apply flex items-center

.description
  @apply max-w-full min-w-0
  @apply text-ellipses-inline t-panel-base fw-$global-fw-base-strong
</style>
